"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextPinComponentSchema = void 0;
const zod_1 = require("zod");
const tip_tap_1 = require("../../tip-tap");
const setting_1 = require("../setting");
const base_pin_component_1 = require("./base-pin-component");
const tiptap_content_schema_1 = require("../tiptap-content.schema");
const TextHorizontalAlignmentSchema = zod_1.z.enum(['left', 'center', 'right', 'justify']);
const TextVerticalAlignmentSchema = zod_1.z.enum(['baseline', 'center', 'end']);
const TypographyTypeSchema = zod_1.z.enum(tip_tap_1.typographyType);
const TextSettingsSchema = base_pin_component_1.BasePinComponentSettingsSchema.merge(zod_1.z.object({
    tipTapContent: tiptap_content_schema_1.TipTapContentSchema,
    textStyleKey: zod_1.z.string().optional(),
    horizontalAlignment: TextHorizontalAlignmentSchema.optional(),
    fontFamily: zod_1.z.string().optional(),
    fontSize: zod_1.z.string().optional(),
    fontWeight: zod_1.z.string().optional(),
    fontColor: zod_1.z.string().optional(),
    fontShadow: setting_1.ShadowSettingKeySchema,
    shadow: setting_1.ShadowSettingKeySchema,
    typographyType: TypographyTypeSchema.optional(),
    verticalAlignment: TextVerticalAlignmentSchema.optional(),
    backgroundColor: zod_1.z.string().optional(),
    borderSize: zod_1.z.number().optional(),
    borderColor: zod_1.z.string().optional(),
    borderRadius: zod_1.z.number().optional(),
    padding: setting_1.PaddingSettingSchema.optional(),
    lineHeight: zod_1.z.number().optional(),
    paragraphSpacing: zod_1.z.number().optional(),
}));
exports.TextPinComponentSchema = base_pin_component_1.BasePinComponentSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('TEXT'),
    settings: TextSettingsSchema,
}));
//# sourceMappingURL=text-pin-component.js.map